import { render, staticRenderFns } from "./Vote.vue?vue&type=template&id=5af4caa8&scoped=true"
import script from "./Vote.vue?vue&type=script&lang=js"
export * from "./Vote.vue?vue&type=script&lang=js"
import style0 from "./Vote.vue?vue&type=style&index=0&id=5af4caa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af4caa8",
  null
  
)

export default component.exports